import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { fuseAnimations } from '@fuse/animations';
import { ODSService } from "app/main/pagina/tools/gestUsu/services/ods.service";
import * as backInter from 'app/auth/auth-data.model';
import Swal from 'sweetalert2';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';

import * as catSecciones from '../cat-secciones';

export interface anios{
  anios: anio[]
};
export interface anio{
  anio: string
}

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  animations : fuseAnimations
})
export class ModalComponent implements OnInit {

  years: anios;
  anioSeleccionado: string;
  paqSel: number;

  tipoPaquete: number;

  plantillas_email:any;
  plantillas_lan:any;
  estilos : any;
  // tipoProducto: number;
  selectSector: number;
  selectPlantilla: any;
  selectPlantillaEmail: any;
  selectEstilo: any;
  selectYear: number;
  statusProductoNorma35:boolean=false;
  surveyToken: string;
  linkRes: string;
  isCA : boolean;

  paquetes: any[] = [
    {clave: 'plata', nombre: 'Paquete PLATA', clase: 'icoSil'},
    {clave: 'oro', nombre: 'Paquete ORO', clase: 'icoOro'},
    {clave: 'platino', nombre: 'Paquete PLATINO', clase: 'icoPla'},
  ];

  listaProductos: any[] = [];
  listaProdsCertificar: any[] = [];
  listaProdsMedir: any[] = [];

  listaProductosElegidos: any[] = [];

  idsProductoActual: any[] = [];

  operacionInterna: boolean;
  idsProductoCA = [9,10,30,31,32,33];
  idsProductoResu_plata = [21,22];
  idsProductoResu_resto = [21,22,23];
  idsProductosMedirNuevo = [11,12,13,14,15,16];
  idsProductosNOM35 = [3,19];
  idsProductosUnicos = [1,3,19,20];  //productos que deben mostrar un unico formulario de modificacion xd
  idsProductosMultiples = [2,4,6,11,12,13,14,15,16];  //ids de productos que pueden asignarse varias veces en un año

  productoMultiple: boolean;
  columnasProdMult: string[] = ['nombre', 'ops'];
  listaProductosMultiples: any[] = [];

  datosProductoConfigurado: any;

  productoConfigurado: boolean;
  normaConfig: boolean;

  constructor(
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private odsService: ODSService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translate: TranslateService
  ) {
    lang_perfiles.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    console.log(this.data);
    if(this.data.anio){
      this.selectYear = this.data.anio;
    }
    if(this.data.idsProductos){
      this.idsProductoActual = this.data.idsProductos;
    }
    if(this.data.tipoPaquete){
      this.tipoPaquete = this.data.tipoPaquete;
    }
    console.log("ids producto actual");
    console.log(this.idsProductoActual);
    if(this.data.productosEmpresa){
      console.log("productos de la empresa");
      console.log(this.data.productosEmpresa);
    }



    this.getYears();
    this.getEstilos();
    this.filtraProductoElegido();
  }

  filtraProductoElegido(){
    if(this.data.numProducto){
      this.ordenaProductos();
      switch (this.data.numProducto) {
        case 1: //certificar
          this.listaProductosElegidos = this.listaProductos[0].productos;
        break;
        case 2: //culture Audit
          // this.listaProductosElegidos = this.listaProductos[6].productos;
          this.listaProductos[6].productos.forEach((element:any) => {
            if(element.idProducto != 8) this.listaProductosElegidos.push(element);  //quita la v1 de culture audit
          });
        break;
        case 3: //Resultados
          switch (this.tipoPaquete) {
            case 1: //paquete plata
              this.listaProductos[7].productos.forEach((elemento:any) => {
                if(this.idsProductoResu_plata.includes(elemento.idProducto)){
                  this.listaProductosElegidos.push(elemento);
                }
              });
            break;
            default:  //resto de paquetes
              this.listaProductos[7].productos.forEach((elemento:any) => {
                if(this.idsProductoResu_resto.includes(elemento.idProducto)){
                  this.listaProductosElegidos.push(elemento);
                }
              });
          }
        break;
        case 4: //medir
          this.listaProductosElegidos = this.listaProductos[1].productos;
        break;
        case 5: //pulse
          this.listaProductosElegidos = this.listaProductos[3].productos;
        break;
        case 6: //focus
          this.listaProductosElegidos = this.listaProductos[4].productos;
        break;
        case 7: //nom35
          this.listaProductosElegidos = this.listaProductos[2].productos;
          if(this.idsProductoActual.length > 0){
            this.normaConfig = true;
          }
        break;
      }
      console.log(this.listaProductos);

      if(this.data.numProducto != 4 && this.data.numProducto != 5 && this.data.numProducto != 6){
        this.listaProductosElegidos.forEach((element:any) => {
          let indice = this.idsProductoActual.findIndex(item => item.clave === element.idProducto);
          if(indice != -1){
            element.configurado = true;
          }
          else element.configurado = false;
        });
      }

      var BreakException = {};
      try {
        this.idsProductoActual.forEach((prodAct:any) => {
          if(this.idsProductosUnicos.includes(prodAct.clave)){
            this.productoConfigurado = true;
            switch (prodAct.clave) {  //switch para agregar el producto y sus datos a una variable para posterior acceso
              case 1: case 20:  //casos de certificar
                this.data.productosEmpresa.productosCertificar.forEach((productoInd:any) => {
                  if(productoInd.idCertificar == prodAct.id){
                    this.datosProductoConfigurado = productoInd;
                    this.datosProductoConfigurado.secciones.sort( (a,b) => {
                      if(a.orden > b.orden){
                        return 1;
                      } else{
                        return -1;
                      }
                    });
                  }
                });
              break;
            }
            this.datosProductoConfigurado.claveProducto = prodAct.clave;
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      };

      console.log(this.listaProductosElegidos);

      console.log("datos producto configurado");
      console.log(this.datosProductoConfigurado);

    }
  }

  ordenaProductos(){
    this.data.productos.productos.forEach(producto => {
      let categoria:any = {};

      switch (producto.idProducto) {
        case 1: case 2: case 3: case 4: case 6: case 7: case 8: case 17: //certificar, medir, nom35, pulsecheck, focus area, drive, ca, resultados

          if(this.data.instituto != 3 && this.data.instituto != 5){  //si no es instituto china o turquia agrega todos los casos de producto
            categoria = {
              nombre: producto.nombreProducto,
              productos: [
                {idProducto: producto.idProducto, activo: true}
              ]
            };
          }
          else{   //si es instituto china o turquia solo agrega el certificar y culture audit
            if(producto.idProducto == 1 || producto.idProducto == 8){
              categoria = {
                nombre: producto.nombreProducto,
                productos: [
                  {idProducto: producto.idProducto, activo: true}
                ]
              };
            }
          }
          if(this.data.instituto ==1 && producto.idProducto ==18 ){
            categoria = {
              nombre: producto.nombreProducto,
              productos: [
                {idProducto: producto.idProducto, activo: true}
              ]
            };
          }
          if(!this.objetoVacio(categoria)){
            this.listaProductos.push(categoria);
          }
        break;
        
        case 9: case 10: case 30: case 31: case 32: case 33: //casos para productos culture audit adicionales: version2 y training
          if(this.data.instituto != 3 && this.data.instituto != 5 && this.data.instituto != 8){  //si no es instituto china, turquia o izzi agrega todos los casos de producto
            categoria = this.listaProductos[6];  //obtiene la lista de productos culture audit
            if(producto.idProducto == 10){  //filtro de producto ca training para instituto mx y cayc
              if(this.data.instituto == 2){
                categoria.productos.push({
                  idProducto: producto.idProducto,
                  activo: true
                });
              }
            }
            if(producto.idProducto == 10 || producto.idProducto == 30 || producto.idProducto == 31 || producto.idProducto == 32 || producto.idProducto == 33 ){  //filtro de producto ca training para instituto mx y cayc
              if(this.data.instituto == 1){
                categoria.productos.push({
                  idProducto: producto.idProducto,
                  activo: true
                });
              }
            }
            else{
              categoria.productos.push({
                idProducto: producto.idProducto,
                activo: true
              });
            }
          }
          else{
            if(this.data.instituto == 5){
              categoria = this.listaProductos[2];  //obtiene la lista de productos culture audit
            }
            else{
              categoria = this.listaProductos[1];
            }
            if(producto.idProducto == 9 && this.data.instituto == 3){  //filtro de producto ca v2 para instituto china
              console.log("Lo agrego brief and");
              categoria.productos.push({
                idProducto: producto.idProducto,
                activo: true
              });
            }

            if(producto.idProducto == 9 && this.data.instituto == 5){  //filtro de producto ca v2 para instituto china
              console.log("Lo agrego brief and");
              categoria.productos.push({
                idProducto: producto.idProducto,
                activo: true
              });
            }
            /*if(producto.idProducto == 10 && this.data.instituto == 5){  //filtro de producto ca v2 para instituto china
              categoria.productos.push({
                idProducto: producto.idProducto,
                activo: true
              });
            }*/
          }
        break;

        case 11: case 12: case 13: case 14: case 15: case 16:   //casos para productos medir adicionales
          if(this.data.instituto != 3 && this.data.instituto != 5){  //si no es instituto china o turquia agrega todos los casos de producto
            categoria = this.listaProductos[1];  //obtiene la lista de productos medir
            categoria.productos.push({
              idProducto: producto.idProducto,
              activo: false
            });
          }
        break;

        case 19:  //caso para producto nom35 beter
        if(this.data.instituto == 1 &&  producto.idProducto == 19 ){

          categoria = this.listaProductos[2];  //obtiene la lista de productos medir
          categoria.productos.push({
            idProducto: producto.idProducto,
            activo: true
          });
        }
        break;

        case 20:  //caso para producto certificar v2
          if(this.data.instituto != 3 && this.data.instituto != 5){  //si no es instituto china o turquia agrega todos los casos de producto
            categoria = this.listaProductos[0];  //obtiene la lista de productos certificar
            categoria.productos = []; //se vacia para borrar el certificar 1
            categoria.productos.push({
              idProducto: producto.idProducto,
              activo: true
            });
          }
        break;

        case 18: case 21: case 22: case 23:  //casos para productos resultados
          if(this.data.instituto != 3 && this.data.instituto != 5){
            categoria = this.listaProductos[7]; //obtiene la lista de productos resultados
            categoria.productos.push({
              idProducto: producto.idProducto,
              activo: true
            })
          }
        break;
      }
    });
  }

  objetoVacio(obj) {
    for(let prop in obj) {
      if(obj.hasOwnProperty(prop)) {
        return false;
      }
    }
    return JSON.stringify(obj) === JSON.stringify({});
  }



  opInterna(idProducto: number, configurado:boolean){
    if(!configurado){
      this.selectSector = idProducto;
      if(this.idsProductoCA.indexOf(this.selectSector) != -1){  //si el ID del producto se encuentra entre las de CA, se guarda de inmediato el producto
        this.isCA = true;
        this.registerProduct();
      }
      else{
        if(this.idsProductosNOM35.includes(this.selectSector)){ //si el producto es uno de nom 35
          Swal.fire({
            title: this.translate.instant('PAQUETES.MENSAJES.ONLYONE'),
            icon: 'warning',
            showCancelButton: true,
reverseButtons: true,
            
            
            confirmButtonText: this.translate.instant('PAQUETES.PREVIO.BOTONES.SI'),
            cancelButtonText: this.translate.instant('PAQUETES.PREVIO.BOTONES.NO')
          }).then((result) => {
            if (result.value) {
              let indice = this.idsProductoActual.findIndex(item => item.clave === idProducto);
              if(indice != -1){
                this.productoConfigurado = true;
              }
              else this.productoConfigurado = false;
              this.operacionInterna = !this.operacionInterna;
              this.getEmail_Plantillas(idProducto,true);
            }
          });
        }
        else{
          let indice = this.idsProductoActual.findIndex(item => item.clave === idProducto);
          if(indice != -1){
            this.productoConfigurado = true;
          }
          else this.productoConfigurado = false;
          this.operacionInterna = !this.operacionInterna;
          this.getEmail_Plantillas(idProducto,true);
          if(this.idsProductosMultiples.indexOf(this.selectSector) != -1){  //si el ID del producto es parte de los productos de tipo multiple
            this.listaProductosMultiples = [];
            console.log("filtro de ids de producto seleccionado");
            console.log(this.idsProductoActual);
            console.log(this.selectSector);
            this.idsProductoActual.forEach((producto:any) => {
              if(producto.clave == this.selectSector){
                this.listaProductosMultiples.push(producto);
              }
            });
            console.log(this.listaProductosMultiples);

            this.productoMultiple = true;
          }
        }
      }
    }
    else{
      Swal.fire({
        title: this.translate.instant('PAQUETES.MENSAJES.PROD_ACTIVADO'),
        icon: 'warning',
        allowOutsideClick: false,
        showCancelButton: false,
      });
    }
  }

  detalleProductoMultiple(datosProducto:any){
    // var BreakException = {};
    // try {
    //   this.listaProductosMultiples.forEach((prodAct:any) => {
        this.productoConfigurado = true;
        switch (datosProducto.clave) {  //switch para agregar el producto y sus datos a una variable para posterior acceso
          case 2:  //caso medir original
            this.data.productosEmpresa.productosMedir.forEach((productoInd:any) => {
              if(productoInd.idMedir == datosProducto.id){
                this.datosProductoConfigurado = productoInd;
              }
            });
          break;
          case 11: case 12: case 13: case 14: case 15: case 16:  //caso otros productos medir
            this.data.productosEmpresa.productosMedir2.forEach((productoInd:any) => {
              if(productoInd.idProducto == datosProducto.id){
                this.datosProductoConfigurado = productoInd;
                if(this.datosProductoConfigurado.secciones){
                  this.datosProductoConfigurado.secciones.sort( (a,b) => {
                    if(a.orden > b.orden){
                      return 1;
                    } else{
                      return -1;
                    }
                  });
                }
              }
            });
          break;
          case 4:  //caso puklsechec
            this.data.productosEmpresa.productosPulseCheck.forEach((productoInd:any) => {
              if(productoInd.idPulseCheck == datosProducto.id){
                this.datosProductoConfigurado = productoInd;
              }
            });
          break;
          case 6:  //caso focus area
            this.data.productosEmpresa.productosFocusArea.forEach((productoInd:any) => {
              if(productoInd.idFocusArea == datosProducto.id){
                this.datosProductoConfigurado = productoInd;
              }
            });
          break;
        }
        this.datosProductoConfigurado.claveProducto = datosProducto.clave;
        this.productoMultiple = false;
        console.log("datos producto configurado, via multiple");
        console.log(this.datosProductoConfigurado);
    //     throw BreakException;
    //   });
    // } catch (e) {
    //   if (e !== BreakException) throw e;
    // };
  }

  cierraListaMultiple(){
    this.productoMultiple = false;
    this.operacionInterna = false;
  }

  nuevoProductoMultiple(){
    this.productoMultiple = false;
    this.productoConfigurado = false;
  }

  getYears() {
    this.odsService.getYearsArray()
    .subscribe((respuesta:anios) => {
      this.years = respuesta;
    }, error => {
      console.log("error", error);
    });
  }

  filtraProductosPaquetes(){
    this.data.productos.forEach(producto => {
      // if(producto.)
    });
  }

  seleccionaPaquete(num:number){
    this.paqSel = num;
  }

  agregaPaquete(){
    if(this.anioSeleccionado && this.paqSel){

      let idProductoSel:number;
      switch (this.paqSel) {
        case 1: idProductoSel = 24; break;
        case 2: idProductoSel = 25; break;
        case 3: idProductoSel = 26; break;
      }
      let data = {
        productoId: idProductoSel,
        nombrePaquete: this.paquetes[this.paqSel-1].clave,
        fechaProducto: this.anioSeleccionado,
        tipo: this.paqSel
      };
      console.log(data);

      this.odsService.matchCompanyProduct(this.data.idEmpresa,data).subscribe((respuesta:any) => {
        if(respuesta.message == "Success"){
          Swal.fire({
            title: this.translate.instant('PAQUETES.MENSAJES.ADDOK'),
            icon: 'success',
            allowOutsideClick: false,
            showCancelButton: false,
          }).then((result) => {
            if (result.value) {
              this.salir(respuesta);
            }
          });
        }
        else if(!respuesta.success){
          Swal.fire({
            title: this.translate.instant('PAQUETES.MENSAJES.NOTOK'),
            icon: 'error',
            allowOutsideClick: false,
            showCancelButton: false,
          });
        }
        // console.log(response);
      });

      // this.salir({anio:this.anioSeleccionado, paq:this.paqSel});
    }
    else{
      if(!this.anioSeleccionado){
        Swal.fire({
          icon: 'warning',
          title: this.translate.instant('PAQUETES.MENSAJES.NOYEAR'),
          confirmButtonColor: '#e40601'
        });
      }
      else if(!this.paqSel){
        Swal.fire({
          icon: 'warning',
          title: this.translate.instant('PAQUETES.MENSAJES.NOPAQ'),
          confirmButtonColor: '#e40601'
        });
      }
    }
  }

  reiniciaVariables(cambio?:boolean){
    if(!cambio){
      this.selectPlantilla = null;
    }
    this.selectPlantillaEmail = null;
    this.selectEstilo = null;
    this.surveyToken = null;
  }

  getEmail_Plantillas(dato: number, activo: boolean) {

    //console.log("PLANTILLAS");
    //console.log(dato);
    this.reiniciaVariables();
    let data = {
      productoId: dato,
      instituto: this.data.instituto
    };
    this.odsService.getEmail_Plantillas(data).subscribe((respuesta: any) => {
      console.log(respuesta);
      if(respuesta.success){
        console.log("Perro plantilass");
        this.plantillas_email = respuesta.paquetes;
        this.plantillas_lan = respuesta.plantillas;
        //this.sendEmail_info(respuesta['paquetes']);
      }


    }, error => {
      console.log("error", error);
    });
    //empieza validacion que cambia a año de ranking si es certificar o a año de aplicacion si es otro producto
    // if(data.productoId == 1){
    //   this.anioranking=true;
    // }
    // else{
    //   this.anioranking=false;
    // }
    // //termina validacion
    //
    // if(dato == 1){
    //   this.flagPasos = true;
    // }else{
    //   this.flagPasos = false;
    // }

  }

  getEstilos() {
    this.odsService.getestilos().subscribe((respuesta: any) => {
      console.log(respuesta);
      this.estilos = respuesta.estilos;
    }, error => {
      console.log("error", error);
    });
  }

  asignarProductoPaquete(data:any){
    if(!this.isCA){
      Swal.fire({
        title: this.translate.instant('PAQUETES.MENSAJES.USURE_PROD'),
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: this.translate.instant('PAQUETES.PREVIO.BOTONES.SI'),
        cancelButtonText: this.translate.instant('PAQUETES.PREVIO.BOTONES.NO')
      }).then((result) => {
        if (result.value) {
          this.registraProducto(data);
        }
      });
    }
    else{
      this.registraProducto(data);
    }
  }

  registerProduct(){
    let secciones = [];
    let data:any = {};
    switch(this.data.instituto) {
      case 1:  secciones = catSecciones.seccionesMX;    break; //MEXICO
      case 2:  secciones = catSecciones.seccionesCAYC;  break; //CAYC
      case 3:  secciones = catSecciones.seccionesHK;    break; //CHINA Y HK
      case 4:  secciones = catSecciones.seccionesSGP;   break; //SINGAPOUR
      case 5:   //TURKEY
        if(this.selectPlantilla.tipo == 1){
          secciones = catSecciones.seccionesTR_1;
        }else if(this.selectPlantilla.tipo == 2){
          secciones = catSecciones.seccionesTR_2;
        }else if(this.selectPlantilla.tipo == 3){
          secciones = catSecciones.seccionesTR_3;
        }
      break;
      case 6:  secciones = catSecciones.seccionesFL;    break; //FILIPINAS
    }


    if(this.selectSector > 0){
      if(this.selectPlantilla != undefined || this.isCA || this.idsProductoResu_resto.includes(this.selectSector)){  //si hay this.selectPlantilla o es CA o es producto resultados
        if(this.selectPlantillaEmail || this.isCA || this.idsProductoResu_resto.includes(this.selectSector)){
          if(this.selectYear > 0){
            if(this.selectEstilo == 0 || this.selectEstilo == 1 || this.isCA || this.idsProductoResu_resto.includes(this.selectSector)){
              //ARMA LOS OBJETOS A ENVIAR AL SERVICE
              if(this.selectSector == 1 || this.selectSector == 20){  // producto certificar o certificar v2
                data = {
                  paqueteId: this.data.paqueteId,
                  productoId: this.selectSector,
                  fechaProducto: this.selectYear,
                  idPlantilla: this.selectPlantilla.idPlantilla,
                  idPaquete: this.selectPlantillaEmail,
                  cssId: this.selectEstilo,
                  secciones : secciones
                };
                if(this.selectSector == 1) data.tipo = 1;
                if(this.selectSector == 20) data.tipo = 2;
              }
              else if(this.idsProductosMedirNuevo.includes(this.selectSector)){  // producto medir mejorado
                data = {
                  paqueteId: this.data.paqueteId,
                  productoId: this.selectSector,
                  fechaProducto: this.selectYear,
                  idPlantilla: this.selectPlantilla.idPlantilla,
                  idPaquete: this.selectPlantillaEmail,
                  cssId: this.selectEstilo,
                  tipo: (this.selectSector-10)
                };
                if(this.selectSector == 11) data.secciones = catSecciones.seccionesMedir_1;
              }
              else if(this.idsProductoResu_resto.includes(this.selectSector)){  // producto resultados
                data = {
                  paqueteId: this.data.paqueteId,
                  productoId: this.selectSector,
                  fechaProducto: this.selectYear
                };
              }
              else if(this.selectSector == 18){  //producto resultados 4all
                data = {
                  paqueteId: this.data.paqueteId,
                  productoId: this.selectSector,
                  fechaProducto: this.selectYear
                };
              }
              else if(this.isCA){   //producto culture audit
                data = {
                  paqueteId: this.data.paqueteId,
                  productoId: this.selectSector,
                  fechaProducto: this.selectYear
                };
                switch (this.selectSector) {
                  case 9: data.tipo = 1; break;
                  case 30: data.tipo = 4; break;
                  case 31: data.tipo = 5; break;
                  case 32: data.tipo = 6; break;
                  case 33: data.tipo = 7; break;
                }
              }
              else{   //resto de productos
                data = {
                  paqueteId: this.data.paqueteId,
                  productoId: this.selectSector,
                  fechaProducto: this.selectYear,
                  idPlantilla: this.selectPlantilla.idPlantilla,
                  idPaquete: this.selectPlantillaEmail,
                  cssId: this.selectEstilo
                };
              }

              //VALIDACIONES DE CAMPOS PERSONALIZADOS PARA REGISTRAR
              if(this.idsProductoResu_resto.includes(this.selectSector)){  //para registrar proucto de resultados
                if(this.selectSector == 22){  //si es el resultados 4all single
                  if(this.linkRes){
                    data.link = this.linkRes;
                    this.asignarProductoPaquete(data);
                  }
                  else{
                    this.openErrorSnackBar("sin link resu",this.translate.instant('ALERTS.OK'));
                  }
                }
                else{
                  if(this.surveyToken && this.linkRes){
                    data.surveyToken = this.surveyToken;
                    data.link = this.linkRes;
                    this.asignarProductoPaquete(data);
                  }
                  else{
                    if(!this.surveyToken){
                      this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SIN_SURVEYTOKEN'),this.translate.instant('ALERTS.OK'));
                    }
                    else if(!this.linkRes){
                      this.openErrorSnackBar("sin link resu",this.translate.instant('ALERTS.OK'));
                    }
                  }
                }
              }
              else if(this.selectSector == 18){  //producto resultados 4all
                console.log("Ha entrado aquí");
                // let url01=$("#url").val();
                let url01="REEMPLAZAR ESTA VRGA CON LA URL XD";
                data.link = url01;
                console.log("Si entro a registrar");
                if(url01.length){
                  console.log("Puede registrar");
                  this.asignarProductoPaquete(data);

                }else{
                  let texto = 'ALERTS.FIELD';
                  this.translate.get(texto).subscribe((res: string) => { texto = res; });

                  console.log("Entro porque hay más de uno en norma");
                  Swal.fire({
                    title: texto,
                    icon: "error",
                    confirmButtonColor: '#e40601'
                  });
                }
              }
              else if(this.selectSector == 19 || this.selectSector == 3){   //si se selecciono norma35 normal o better
                if(this.statusProductoNorma35){   //si ya cuenta con un producto de norma 35
                  let texto = 'ALERTS.LABEL01';
                  this.translate.get(texto).subscribe((res: string) => { texto = res; });
                  Swal.fire({
                    title: texto,
                    icon: "error",
                    confirmButtonColor: '#e40601'
                  });
                }
                else{
                  if(this.selectSector == 3){
                    data.tipo = 1;
                    this.asignarProductoPaquete(data);
                  }
                  else if(this.selectSector == 19){
                    data.tipo = 2;
                    this.asignarProductoPaquete(data);
                  }
                }
              }
              else{   //resto de productos
                this.asignarProductoPaquete(data);
              }


            }else{
              this.openErrorSnackBar('falta estilo de caras','OK');
            }
          }else{
            this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.MSJ_SELECTYEAR'),this.translate.instant('ALERTS.OK'));
          }
        }
        else{
          this.openErrorSnackBar('falta plantilla comuniacion','ok');
        }
      }else{
        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.MSJ_SELECTTEMPLETE'),this.translate.instant('ALERTS.OK'));
      }
    }else{
      this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.MSJ_SELECTPRODUCT'),this.translate.instant('ALERTS.OK'));
    }
  }

  registraProducto(data:any){
    console.log("datos a enviar alv");
    console.log(data);
    this.odsService.matchCompanyProduct(this.data.idEmpresa,data).subscribe((respuesta:any) => {
      console.log(respuesta);

      if(respuesta.message == 'Success'){
        Swal.fire({
          title: this.translate.instant('PERFILES.USUARIO.PRODUCT_REGISTEROK'),
          icon: 'success',
          allowOutsideClick: false,
          showCancelButton: false,
        }).then((result) => {
          if (result.value) {
            this.salir(respuesta);
          }
        });
        // this.restoreData();
        // this.reiniciaVariables();
        // this.openSuccessSnackBar(this.translate.instant('PERFILES.USUARIO.PRODUCT_REGISTEROK'),this.translate.instant('ALERTS.OK'));
        // this.getProductsByCompany();
      }else if(respuesta.message == 'Success2'){
        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.PRODUCT_REGISTERPREVIOUS'),this.translate.instant('ALERTS.OK'));
      }else if(respuesta.message == '700'){
        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.CERTIFICAR_EXISTENTE'),this.translate.instant('ALERTS.OK'));
      }else if(respuesta.message == '703'){
        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.CERTIFICAR_NO_TERMINADO'),this.translate.instant('ALERTS.OK'));
      }else if(respuesta.message == '701'){
        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.CERTIFICAR_NO_EXISTENTE'),this.translate.instant('ALERTS.OK'));
      }else if(respuesta.message == '722'){
        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.SIN_USUARIO'),this.translate.instant('ALERTS.OK'));
      }
      else{
        this.openErrorSnackBar(this.translate.instant('PERFILES.USUARIO.PRODUCT_REGISTERFAIL'),this.translate.instant('ALERTS.OK'));
      }

    }, error => {
      console.log(error);
    });
  }

  openErrorSnackBar(message: string, action: string) {
    Swal.fire({
      icon: 'error',
      title: message,
      confirmButtonText: action,
      confirmButtonColor: '#e40601'
    });
  }

  drop(event: CdkDragDrop<string[]>,arreglo:any, fecha:number, idProducto?:any) {
    //console.log(arreglo);
    moveItemInArray(arreglo, event.previousIndex, event.currentIndex);
    this.updatePosition(arreglo,fecha,idProducto);
  }

  updatePosition(arreglo:any[],fecha:number,idProducto?:any){

    arreglo.forEach((elemento:any, i) => {
      let data: any = {
        seccionId: elemento._id,
        orden: i+1
      };
      if(idProducto){
        data.productoId = idProducto;
      }
      else{
        data.fechaCertificar = fecha;
      }
      // console.log(data);
      this.odsService.updateStatus(this.data.idEmpresa,data).subscribe((respuesta:any) => {
        console.log(respuesta);
      }, error => {
        console.log(error);
      });
    });

  }


  updateStatus(event:any, seccion:any, fecha?:number, idProducto?:any){
    let data:any = {
      seccionId: seccion,
      estatus: event['checked']
    };
    if(idProducto){
      data.productoId = idProducto;
    }
    else{
      data.fechaCertificar = fecha;
    }
    // console.log(data);
    this.odsService.updateStatus(this.data.idEmpresa,data).subscribe(response => {
      //console.log(response);
    }, error => {
      console.log(error);
    });
  }

  salir(respuesta?:any) {
    this.dialogRef.close(respuesta);
  }

}
